import * as React from "react";

/** Layout étroit (mobile / tablette), max-width 1023px — aligné sur le breakpoint sidebar. */
export function useNarrowLayout() {
  const [narrow, setNarrow] = React.useState(false);
  React.useEffect(() => {
    const mq = window.matchMedia("(max-width: 1023px)");
    const update = () => setNarrow(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return narrow;
}
